import React from "react";
import { Link } from "react-router-dom";
import { FEATURED_PRESS } from "./constants";
import { Newspaper } from "lucide-react";

/**
 * Compact "FEATURED IN" credibility row. Tasteful, grant-reviewer-friendly.
 * Shows the unique set of outlets from FEATURED_PRESS. Each is a quiet link
 * to the press page where readers can find the full coverage.
 */
export default function FeaturedIn() {
  // De-dupe outlets so two pieces from the same paper don't render twice.
  const outlets = Array.from(new Set(FEATURED_PRESS.map((p) => p.outlet)));
  if (outlets.length === 0) return null;

  return (
    <section className="border-y border-brand/10 bg-background" data-testid="featured-in">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
        <p className="text-xs uppercase tracking-[0.25em] text-foreground/55 flex items-center gap-2">
          <Newspaper className="w-3.5 h-3.5 text-brand" /> Featured in
        </p>
        {outlets.map((o) => (
          <Link
            key={o}
            to="/press"
            data-testid={`featured-in-${o.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="font-serif text-base sm:text-lg text-foreground/80 hover:text-brand transition-colors italic"
          >
            {o}
          </Link>
        ))}
      </div>
    </section>
  );
}
